import React, { useState } from 'react'
import { Divider, Layout, Menu } from 'antd';
import '../../style/component.css'
import { staffRoutes } from './SidebarMenuRoute';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/authContext';
import { canAccess } from '../../utils/CanAccess';
import { useSelector } from 'react-redux';
import { Roles } from '../../constant/Constatnt';

const { Sider } = Layout;


function StaffSidebarMenu() {
    const { dashboardData, permissionMap } = useSelector((state) => state.staffDashboards);
    const { role } = useAuth();
    const location = useLocation();
    const [openKeys, setOpenKeys] = useState([]);


    const onOpenChange = (keys) => {
        const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
        setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    };

    const findSelectedKey = (path) => {
        for (const route of staffRoutes) {
            if (route.path === path) return route.key;
            if (route.children) {
                for (const subRoute of route.children) {
                    if (subRoute.path === path) return subRoute.key;
                }
            }
        }
        return '';
    };

    const selectedKey = findSelectedKey(location.pathname);

   
    const filterRoutes = (routes, permissions) => {
        return routes
            .map((route) => {
               
                if (route.type === "group") {
                    if (!route.groups || !route.groups.length) return null;

                    const hasAccessToAnyGroup = route.groups.some((module) =>
                        canAccess(permissions, module, "view")
                    );

                    return hasAccessToAnyGroup ? route : null;
                }
                if (route.permission) {
                    const parentAllowed = canAccess(
                        permissions,
                        route.permission.module,
                        "view"
                    );

                    if (!parentAllowed) return null;
                }

                if (route.children) {
                    return { ...route, children: route.children };
                }


                // ✅ Public route → allow for everyone
                if (route.public) return route;

                // ❌ No permission & not public → block
                if (!route.permission) return null;

                // Check permission
                const allowed = canAccess(
                    permissions,
                    route.permission.module,
                    route.permission.action || "view"
                );

                if (!allowed) return null;

                // Handle children properly
                if (route.children?.length) {
                    const children = filterRoutes(route.children, permissions);
                    return children.length ? { ...route, children } : null;
                }

                return route;
            })
            .filter(Boolean);
    };


    const allowedRoutes = filterRoutes(staffRoutes, permissionMap);

    return (
        <Sider

            className='sidebar'
            width={240}
            theme="light"
            breakpoint="lg"
            collapsedWidth="0"
            onBreakpoint={(broken) => {
                console.log(broken);
            }}
            onCollapse={(collapsed, type) => {
                console.log(collapsed, type);
            }}
        >
            <Menu
                disabled={dashboardData?.role === Roles.manager && !dashboardData?.isPresent}
                theme="light"
                mode="inline"
                defaultSelectedKeys={[selectedKey]}
                openKeys={openKeys}
                onOpenChange={onOpenChange}
            >
                {allowedRoutes.map((route, index) => {
                    if (route.children) {
                        return (
                            <Menu.SubMenu
                                key={route.key}
                                title={<span className="menu_item">{route.label}</span>}
                                icon={<span className="side_menu_icon">{route.icons}</span>}
                            >
                                {route.children.map((subRoute, subIndex) => (
                                    <Menu.Item
                                        key={subRoute.key}
                                        icon={<span className="side_menu_icon">{subRoute.icons}</span>}
                                    >
                                        <NavLink to={subRoute.path} >{subRoute.label}</NavLink>
                                    </Menu.Item>
                                ))}
                            </Menu.SubMenu>
                        );
                    }
                    return (
                        <>
                            {route.type === "group" ? <Menu.Item
                                key={route.key}
                            >
                                <div>
                                    <span className='group_label'>{route.label}</span>
                                </div>
                            </Menu.Item> :
                                <Menu.Item
                                    key={route.key}
                                    icon={<span className="side_menu_icon">{route.icons}</span>}

                                >
                                    <NavLink to={route.path}>
                                        <span className='menu_item'> {route.label}</span>
                                    </NavLink>

                                </Menu.Item>}
                        </>
                    );
                })}
                <Divider />
            </Menu>
        </Sider>
    )
}

export default StaffSidebarMenu

